import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function MakeupAirUnitIcon(props) {
	return (
		<IconBase type="makeup-air-unit" {...props}>
			<path d="M7.5 6H7V6.5H3.5L1 9L7 15V16H7.5V6Z" />
			<path d="M14.5 6.5H8.5V6H8V16H8.5V15.5H21.5V16H22V6H21.5V6.5H15V6H14.5V6.5Z" />
			<path d="M21 18V16H9V18H21Z" />
		</IconBase>
	);
}
MakeupAirUnitIcon.propTypes = iconPropTypes;
